import { render, staticRenderFns } from "./AppCheckboxGroup.vue?vue&type=template&id=5615ee98&"
import script from "./AppCheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./AppCheckboxGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports